import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserService } from 'src/shared/services/user/user.service';
import { OnlyOfficeService } from './only-office.service';
import { CONNECTOR_URL } from 'src/environments/environment.prod';
@Component({
  selector: 'only-office',
  templateUrl: './only-office.component.html',
  styleUrls: ['./only-office.component.scss']
})
export class OnlyOfficeComponent implements OnInit {

  
  public nodeId:String = "";
  public filename:String = "";
  public fileType:String = "";
  public fileTitle:String = "";
  public myConfig:any = "";
  public res:any;
  public userId:String = "";
  public userFirstnameLastName:String = "";

  constructor(private httpClient: HttpClient, private onlyOfficeservice:OnlyOfficeService,private userservice:UserService){
  
    this.nodeId = this.onlyOfficeservice.nodeToEdit.id;
    this.fileType = this.onlyOfficeservice.nodeToEdit.name.split(".")[1];
    this.userId = this.userservice.user.id;
    this.userFirstnameLastName = this.userservice.user.firstname +" "+this.userservice.user.lastname; 
    this.fileTitle = this.onlyOfficeservice.nodeToEdit.name
    this.httpClient.post("https://pulse-interne.synapture.fr/onlyoffice-connector/init",{ nodeId : this.nodeId, extension : this.fileType }).subscribe((result) => {
      this.res = result;
      this.myConfig = { 
        editorConfig: {
          document: {
            fileType: this.fileType,
            key: this.res.key,
            permissions: {
              download: true,
              edit: true,
            },
            title: this.fileTitle,
            url: `https://pulse-interne.synapture.fr/onlyoffice-connector/getFile/${this.res.filename}`,
          },
          editorConfig: {
            callbackUrl : CONNECTOR_URL+`/onlyoffice-connector/track?filename=${this.res.filename}`,
            user: {
              id: this.userId,
              name: this.userFirstnameLastName,
            }
          },
          events: {
            onBack: console.log,
            onDocumentStateChange: console.log,
            onError: console.log,
            onReady: console.log,
            onRequestEditRights: console.log,
            onSave: console.log,
          },
          height: "100%",
          type: "desktop",
          width: "100%",
        },
        script: "./web-apps/apps/api/documents/api.js"
      };
    })

  }

  ngOnInit(): void {

  }

}
